module.exports = __webpack_public_path__ + "static/media/face-9.c1e5cedd.jpg";